import React, {useEffect, useState} from 'react';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { coy } from 'react-syntax-highlighter/dist/esm/styles/prism';

const PythonExample = (props) => {
    const {method, url, data, headers, paramsType, changeCodeText, customStyle, secretKey} = props;
    const [codeText, setCodeText] = useState('');

    useEffect(() => {
        const {method, url, data, headers, paramsType, changeCodeText, customStyle, secretKey} = props;
        const getDataCodeStrings = (data) => {
            if (method.toLowerCase() === 'get') return [];
            else {

                let out = ['data = {'];
                for (let key in data) {
                    if (key == "clientId") continue;
                    out.push(`\t"${key}": "${data[key]}",`);
                }
                out.push("}");
                return out;
            }
        };

        const getHeadersCodeStrings = (headers) => {
            let out = ['headers = {']
            for (let key in headers) {
                if (key == "sign") {
                    out.push(`\t"${key}": get_sign(data, secret),`);
                } else {
                    out.push(`\t"${key}": "${headers[key]}",`);
                }
            }
            out.push("}")
            return out;
        };

        const getPayloadType = (paramsType) => {
            if (paramsType.toLowerCase() === 'json') return 'json';
            else if (paramsType.toLowerCase() === 'url') return 'data';
        };

        const getResultRequestString = (method, paramsType) => {
            if (method.toLowerCase() === 'post')
                return `requests.request("POST", url=url, ${getPayloadType(paramsType)}=data, headers=headers).text`;
            else if (method.toLowerCase() === 'get')
                return 'requests.request("GET", url=url, headers=headers).text';
        };
        const getUrl = (url) => {
            return url.replace(/users\/(.*)\/session/, 'users/{data[\'userId\']}/session');
        }

        let codeStrings = [
            'import requests',
            'import hashlib',
            'from collections import OrderedDict',
            '',
            '',
            'def sort_od(od):',
            '\tres = OrderedDict()',
            '\tfor k, v in sorted(od.items()):',
            '\t\tif isinstance(v, dict):',
            '\t\t\tres[k] = sort_od(v)',
            '\t\telse:',
            '\t\t\tres[k] = v',
            '\treturn res',
            '',
            '',
            'def implode_recursive(arr, separator: str = ""):',
            '\tstr_p = ""',
            '\tif isinstance(arr, dict):',
            '\t\tvalues = arr.values()',
            '\telse:',
            '\t\tvalues = arr',
            '\tfor val in values:',
            '\t\tif isinstance(val, (list, tuple, dict)):',
            '\t\t\tstr_p = str_p + str(implode_recursive(val)) + separator',
            '\t\telse:',
            '\t\t\tstr_p = str_p + str(val) + separator',
            '\treturn str_p[0:len(str_p) - len(separator)]',
            '',
            '',
            '# Get the signature that can be used in queries',
            'def get_sign(params: dict, secret_key: str) -> str:',
            '',
            '\t# Sort the parameters',
            '\tparams = sort_od(params)',
            '',
            '\t# Concatenate the parameters into a string',
            '\tstr_params = implode_recursive(params)',
            '',
            '\t# Add a secret key to the string',
            '\tstr_params += secret_key',
            '',
            '\t# Generate a signature using the SHA256 algorithm',
            '\tm = hashlib.sha256()',
            '\tm.update(str(str_params).encode("utf-8"))',
            '\tsign = m.hexdigest()',
            '',
            '\treturn sign',
            '',
            '', 
            '# Required data',
            ...getDataCodeStrings(data),
            `url = f"${getUrl(url)}"`,
            `secret = "${secretKey}"`,
            '',
            ...getHeadersCodeStrings(headers),
            'data.pop("userId")',
            '',
            'response = requests.request(method="POST", url=url, data=data, headers=headers)',
            ''
        ];
        const newCodeText = codeStrings.join('\n');
        setCodeText(newCodeText);
        changeCodeText(newCodeText);
    });


    return (
        <div className="python-example">
            <SyntaxHighlighter
                language="bash"
                style={coy}
                wrapLines={true}
                customStyle={customStyle}
            >
                {codeText}
            </SyntaxHighlighter>
        </div>
    );
}

export default PythonExample;
